var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReadyToUseRewards = function SvgReadyToUseRewards(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17645_80497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 21H26.5V35H41.5C42.6046 35 43.5 34.1046 43.5 33V21Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 35H2.5C1.39543 35 0.5 35.8954 0.5 37V39H63.5V35Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 15C45.5 13.8954 44.6046 13 43.5 13H26.5V21H45.5V15Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 9.00001C32.5 11.2091 30.7091 13 28.5 13C27.2628 13 23.7308 13 22.5 13C22.5 11.4615 22.5 9.97196 22.5 9.00001C22.5 6.79088 24.2909 5.00002 26.5 5.00002C27.5902 5.00002 31.3 5 32.5 5C32.5 6.6 32.5 7.88106 32.5 9.00001Z",
    fill: "#FFD977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 9C36.5 11.2091 34.7091 13 32.5 13C31.2628 13 29.7308 13 28.5 13C28.5 11.4615 28.5 9.97195 28.5 9C28.5 6.79086 30.2909 5 32.5 5C34.7091 5 36.5 6.79086 36.5 9Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 12.4642C29.6956 11.7726 30.5 10.4799 30.5 8.99933C30.5 7.98489 30.1224 7.05865 29.5 6.35352C28.8776 7.05865 28.5 7.9849 28.5 8.99935L28.5 12.4642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19H6.5V33C6.5 34.1046 7.39543 35 8.5 35H26.5C27.6046 35 28.5 34.1046 28.5 33V19Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 2,
    transform: "matrix(-1 0 0 1 29.5 19)",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15C30.5 13.8954 29.6046 13 28.5 13H6.5C5.39543 13 4.5 13.8954 4.5 15V19H30.5V15Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 22,
    transform: "matrix(-1 0 0 1 20.5 13)",
    fill: "#FFD977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.00001C14.5 11.2091 16.2909 13 18.5 13C19.7372 13 23.2692 13 24.5 13C24.5 11.4615 24.5 5.97194 24.5 5C22.1 5 20.7091 5.00002 18.5 5.00002C16.2909 5.00002 14.5 6.79088 14.5 9.00001Z",
    fill: "#FFD977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9C20.5 11.2091 22.2909 13 24.5 13C25.7372 13 27.2692 13 28.5 13C28.5 11.4615 28.5 9.97195 28.5 9C28.5 6.79086 26.7091 5 24.5 5C22.2909 5 20.5 6.79086 20.5 9Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12.4642L22.5 8.99933C22.5 7.98489 22.1224 7.05865 21.5 6.35352C20.8776 7.05865 20.5 7.9849 20.5 8.99935C20.5 10.4799 21.3044 11.7726 22.5 12.4642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17645_80497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReadyToUseRewards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ready-to-use-rewards.afd4615733677d6232eab9ffcd8c5d50.svg";